@if (!isMobile) {
	<p-toast></p-toast>
	<p-confirm-dialog />
	<div class="desktop">
		<div class="page">
			<bas-nav-header></bas-nav-header>
			<div class="content">
				<div class="content-area-container">
					<div class="content-area">
						<router-outlet></router-outlet>
						@if (showMainNav() && canSeeDebugLinks()) {
							<div class="links">
								<a class="defaultLink debugItem"
								   routerLink="/service/uilab-branching-mask.do">UI Lab</a>
							</div>
						}
					</div>
					@if (showMainNav()) {
						<div class="back-to-top-container">
							<div tabindex="0"
								 class="backToTopDiv"
								 (keydown.enter)="scrollToTop()">
								<div class="back-to-top"
									 (click)="scrollToTop()"></div>
							</div>
						</div>
					}
					<bas-nav-footer></bas-nav-footer>
				</div>
			</div>
		</div>
	</div>
} @else {
	<div class="mobile-page"
		 [class.mobile-login]="isLoginPage()">
		@if (showNavHeader()) {
			<bas-nav-header></bas-nav-header>
		}
		@if (showMobileNav()) {
			<bas-mobile-nav></bas-mobile-nav>
		}
		<router-outlet></router-outlet>
		@if (showNavFooter()) {
			<bas-nav-footer></bas-nav-footer>
		}
	</div>
}